import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=21f2fe38"
import script from "./RejectDialog.ts?vue&type=script&lang=ts&external"
export * from "./RejectDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports